export default {
  name: "Portfolio",
  props: ["portfolioData", "rankingLastRow"],

  methods: {
    getTwoFixedVal(value) {
      if (
        isNaN(value) ||
        value == 0 ||
        value == "-" ||
        value == null ||
        value == ""
      ) {
        return "-";
      } else {
        return parseFloat(value).toFixed(2);
      }
    },

    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    }
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/Report/Portfolio.js